import React from "react";
import PropTypes from "prop-types";
import { Container } from "@material-ui/core";
import { useStaticQuery, graphql } from "gatsby";
import CardContainer from "../components/card-container";
import SectionHead from "../components/section-head";
import BlogCard from "../components/blog-card";
import TextCard from "../components/text-card";
import { _ } from "../utils/i18n";

const PostFeed = ({
  categories,
  fixedPosts,
  postsPerPage,
  showDate,
  type = "post",
}) => {
  const { comp, cat } = useStaticQuery(
    graphql`
      query {
        comp: allWpContentNode(
          filter: { nodeType: { in: ["Case", "Page", "Post", "Service"] } }
          sort: { date: DESC }
        ) {
          edges {
            node {
              databaseId
              contentTypeName
              uri
              slug
              date

              ... on WpCase {
                title

                categories {
                  nodes {
                    name
                    databaseId
                    uri
                  }
                }
                featuredImage {
                  node {
                    sourceUrl
                    altText
                  }
                }
              }

              ... on WpPage {
                hasAcfCf7Career: containsBlock(name: "acf/cf7-career")
                hasCareerForm: containsBlock(
                  name: "contact-form-7/contact-form-selector"
                  attributes: { rendered: { match: "your-cv" } }
                )

                title

                categories {
                  nodes {
                    name
                    databaseId
                  }
                }
                featuredImage {
                  node {
                    sourceUrl
                    altText
                  }
                }
                tags {
                  nodes {
                    name
                  }
                }
              }

              ... on WpPost {
                title

                categories {
                  nodes {
                    name
                    databaseId
                    uri
                  }
                }
                featuredImage {
                  node {
                    sourceUrl
                    altText
                  }
                }
              }

              ... on WpService {
                title

                categories {
                  nodes {
                    name
                    databaseId
                  }
                }
                featuredImage {
                  node {
                    sourceUrl
                    altText
                  }
                }
              }
            }
          }
        }
        cat: allWpCategory {
          edges {
            node {
              name
              databaseId
              parentDatabaseId
              description
              uri
              acfRelatedContentLink {
                link {
                  ... on WpPost {
                    databaseId
                  }
                  ... on WpService {
                    databaseId
                  }
                  ... on WpCase {
                    databaseId
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  const fixedPostsIndexArray = fixedPosts?.map((post) => post.databaseId);
  const categoriesIndexArray = categories?.map(
    (category) => category.databaseId
  );
  var posts = [];
  const casePosts = 1000;
  if (fixedPosts?.length > 0) {
    posts = comp.edges
      .filter(({ node }) => fixedPostsIndexArray.indexOf(node.databaseId) > -1)
      .sort(function (a, b) {
        return (
          fixedPostsIndexArray.indexOf(a.node.databaseId) -
          fixedPostsIndexArray.indexOf(b.node.databaseId)
        );
      });
  } else if (categories?.length > 0) {
    posts = comp.edges.filter(function ({ node }) {
      return node?.categories?.nodes?.find((category) =>
        categories.includes(category.databaseId)
      );
    });
  } else {
    posts = comp.edges;
  }
  posts = comp.edges;
  var postnum = postsPerPage > 0 ? postsPerPage : 9;
  return (
    <Container maxWidth="lg" className="disable-padding">
      {type === "cat" && (
        <div
          className="row-container"
          style={{ justifyContent: "space-between", marginBottom: "1rem" }}
        >
          {categories?.length > 0 &&
            cat.edges
              .filter(
                ({ node }) =>
                  categoriesIndexArray.indexOf(node.parentDatabaseId) > -1
              )
              .map((c, i) => (
                <TextCard
                  key={i}
                  title={c.node.name}
                  excerpt={c.node?.description}
                  linkUrl={String(
                    c.node.acfRelatedContentLink?.link?.databaseId
                      ? posts
                          .filter(
                            ({ node }) =>
                              c.node.acfRelatedContentLink.link.databaseId ===
                              node.databaseId
                          )
                          .map((p) => (p.node.uri ? p.node.uri : "null"))
                      : "null"
                  )}
                />
              ))}
        </div>
      )}

      {type === "page" && (
        <CardContainer itemType="Blog">
          {fixedPosts?.length > 0 &&
            comp.edges
              .filter(
                ({ node }) => fixedPostsIndexArray.indexOf(node.databaseId) > -1
              )
              .sort(function (a, b) {
                return (
                  fixedPostsIndexArray.indexOf(a.node.databaseId) -
                  fixedPostsIndexArray.indexOf(b.node.databaseId)
                );
              })
              .slice(0, postnum)
              .map((post, i) => (
                <BlogCard
                  key={i}
                  imgSize="small"
                  imgUrl={post.node.featuredImage?.node.sourceUrl}
                  link={
                    (post.node.contentTypeName === "post" ? "" : "") +
                    post.node.uri
                  }
                  date={post.node.date}
                  showDate={showDate}
                  category={post.node.categories?.nodes?.[0]?.name}
                  title={post.node.title}
                  linkCategory={post.node.categories?.nodes?.[0]?.uri}
                  bulletPoints={post.node.tags?.nodes?.map(({ name }) => name)}
                  hasApplyBtn={
                    post.node.hasAcfCf7Career || post.node.hasCareerForm
                  }
                />
              ))}
        </CardContainer>
      )}

      {type !== "cat" && type !== "page" && (
        <CardContainer itemType="Blog">
          {postsPerPage === "3" && (
            <SectionHead type="h2" title={_("Populære innlegg")} />
          )}
          {postsPerPage === "3" && <div></div>}
          {postsPerPage === "3" && <div></div>}

          {posts
            .filter(({ node }) => node.contentTypeName === type)
            .slice(0, type === "case" ? casePosts : postnum)
            .map((post, i) => (
              <BlogCard
                key={i}
                imgSize="small"
                imgUrl={post.node.featuredImage?.node.sourceUrl}
                link={
                  (post.node.contentTypeName === "post" ? "" : "") +
                  post.node.uri
                }
                date={post.node.date}
                showDate={showDate}
                category={post.node.categories?.nodes?.[0]?.name}
                linkCategory={post.node.categories?.nodes?.[0]?.uri}
                title={post.node?.title}
                bulletPoints={post.node.tags?.nodes?.map(({ name }) => name)}
                hasApplyBtn={
                  post.node.hasAcfCf7Career || post.node.hasCareerForm
                }
              />
            ))}
        </CardContainer>
      )}
    </Container>
  );
};

PostFeed.propTypes = {
  categories: PropTypes.array,
  fixedPosts: PropTypes.array,
  postsPerPage: PropTypes.number,
  showDate: PropTypes.bool,
  type: PropTypes.string,
};

PostFeed.defaultProps = {
  categories: undefined,
  fixedPosts: undefined,
  postsPerPage: undefined,
  showDate: undefined,
  type: undefined,
};

export default PostFeed;
